import React from 'react';
import { Box, Icon, Optional } from '@honda-canada/design-system-react';
import TrimCarousel from './TrimCarousel';
import TrimThreeSixtyImageView from './TrimThreeSixtyImageView';
import themeStyles from './TrimOverview.styles';
const LoaderIconContainer = themeStyles.apply(Box, 'LoaderIconContainer');
const TrimAssets = ({ gtmVehicleData, placeholderImage, carouselImages, accessoriesWithOverlayImages, threeSixtyInteriorImages, threeSixtyExteriorImages, isFetching, showThreeSixty, showPlaceholder, isExterior, isInventoryVariant, }) => {
    if (isFetching) {
        return (React.createElement(LoaderIconContainer, null,
            React.createElement(Icon, { name: "animated360Loader" })));
    }
    const vehicleCarouselImages = placeholderImage ? [placeholderImage] : carouselImages;
    if (!showThreeSixty && !(vehicleCarouselImages === null || vehicleCarouselImages === void 0 ? void 0 : vehicleCarouselImages.length)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Optional, { when: showThreeSixty },
            React.createElement(TrimThreeSixtyImageView, { assets360Images: { interior: threeSixtyInteriorImages, exterior: threeSixtyExteriorImages }, gtmVehicleData: gtmVehicleData, accessoriesWithOverlayImages: accessoriesWithOverlayImages || [], isInventoryVariant: isInventoryVariant })),
        React.createElement(Optional, { when: !showThreeSixty },
            React.createElement(TrimCarousel, { images: showPlaceholder && placeholderImage ? [placeholderImage] : carouselImages, accessoriesWithOverlayImages: accessoriesWithOverlayImages || [], gtmVehicleData: gtmVehicleData, isExterior: isExterior || showPlaceholder, showPlaceholder: showPlaceholder, isInventoryVariant: isInventoryVariant }))));
};
export default TrimAssets;
